// PDF generation API — mirrors backend src/apps/api/spectre/api/routers/v1/pdf.py.
//
// The backend persists the generated PDF to object storage and returns the
// bytes inline. The client also detects `application/pdf` and resolves the
// promise with a Blob (see ApiClient.parseResponse).
import { apiClient } from './client'

export interface PdfTemplate {
  /** Stable identifier passed back to /pdf/generate. */
  name: string
  /** i18n key for the human-readable template title. */
  title_key: string
  /** Subject kind the template operates on (e.g. "identity"). */
  subject_type: string
  /** Locales the template ships translations for (e.g. ["en", "cs", "th"]). */
  locales: string[]
}

export interface ListTemplatesResponse {
  templates: PdfTemplate[]
}

export interface GeneratePdfRequest {
  template: string
  subjectRef: string
  caseId: string
  locale?: string
}

export const pdfApi = {
  listTemplates: () => apiClient.get<ListTemplatesResponse>('/v1/pdf/templates'),

  generate: ({ template, subjectRef, caseId, locale = 'en' }: GeneratePdfRequest) =>
    apiClient.post<Blob>(
      '/v1/pdf/generate',
      {
        template,
        subject_ref: subjectRef,
        case_id: caseId,
        locale,
      },
      { responseType: 'blob' }
    ),
}
